import { render, staticRenderFns } from "./RegistroCapacitaciones.vue?vue&type=template&id=c4910848&scoped=true&"
import script from "./RegistroCapacitaciones.vue?vue&type=script&lang=js&"
export * from "./RegistroCapacitaciones.vue?vue&type=script&lang=js&"
import style0 from "./RegistroCapacitaciones.vue?vue&type=style&index=0&id=c4910848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4910848",
  null
  
)

export default component.exports